// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".freelance-menu-left{position:sticky;top:3rem}.freelance-menu-left .menu-content{box-shadow:0 5px 20px rgba(27,35,46,0.2);margin-bottom:1rem;padding:1rem}.freelance-menu-left .link-profile{text-align:center;margin:0 auto 1rem;display:block}\n", ""]);
// Exports
module.exports = exports;
